import type { FreelancerCompetenciesInformationPageLocales } from '../types';

const freelancerCompetenciesInformationPageLocales: FreelancerCompetenciesInformationPageLocales =
  {
    competences: 'Competences',
    CompetencesAdded: 'Competences added',
    competencesRequired: 'Please select at least one competence',
    licenses: 'Licenses',
    needMoreInformation:
      'We need some more information from you to finalize your registration.',
    ownsDriverLicense: 'I own a drivers license.',
    ownsStintLicense: 'I own a stint license.',
    selectCompetences: 'Select Competences',
    title: 'Personal information',
  };

export default freelancerCompetenciesInformationPageLocales;
